/*
 * getFirstNamePossessive
 * --------------------------------------------------------------------------
 * Parse the first token of a user.name string (e.g. "Justin Proetto" → "Justin")
 * and return the possessive form ("Justin's").
 *
 * Returns '' if user or user.name is absent. Under the AuthGuard contract
 * (Auth0 only flips isAuthenticated to true after the user object is fully
 * hydrated), .name should always exist for descendants of AuthGuard — the
 * empty-string return is a defensive fallback for any caller above the guard
 * or a future SDK change that decouples isAuthenticated from full hydration.
 */

export const getFirstNamePossessive = (user) => {
    if (!user?.name) return ''
    const firstName = user.name.split(' ')[0]
    return `${firstName}'s`
}

export default getFirstNamePossessive
